import React from "react";
import { IoIosArrowDown, IoMdSettings } from "react-icons/io";
import { ReactSVG } from "react-svg";

const PromptDropdown = ({
  isMobile,
  isOpen,
  setIsOpen,
  selected,
  promptOptions,
  setSelected,
  onMakeDefault,
  defaultPromptId,
}) => {
  return (
    <div className={`relative ${isMobile ? "flex lg:hidden" : "lg:flex hidden"} flex-col`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{ "--bgs": selected?.bgColor }}
        className="flex justify-between items-center p-3 my-2 md:text-base text-sm bg-[#F1FAFF] rounded-lg font-inter w-full text-[#363636]"
      >
        <span className="flex items-center gap-2">
          <span className="p-2 rounded-md transition bg-[var(--bgs)]">
            <ReactSVG
              src={selected.icon}
              beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
            />
          </span>
          {selected.label}
        </span>
        <IoIosArrowDown
          className={`transition-transform duration-300 ${
            isOpen ? "md:rotate-180 rotate-0" : "md:rotate-0 rotate-180"
          }`}
        />
      </button>

      <ul
        className={`absolute w-full rounded-lg max-h-36 overflow-y-auto bg-[#F1FAFF] transform transition-all duration-500 origin-top top-16 z-50 ${
          !isMobile ? "shadow-md custom-scrollbar" : ""
        } ${isOpen ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0 pointer-events-none"}`}
      >
        {promptOptions.map((opt, idx) => (
          <li
            key={opt.id || idx}
            style={{ "--bg": opt?.bgColor }}
            className="group flex items-center justify-between gap-2 p-3 cursor-pointer hover:bg-[#3AB1F6] hover:text-white text-base font-inter transition"
          >
            <button
              type="button"
              onClick={() => {
                setSelected(opt);
                setIsOpen(false);
              }}
              className="flex min-w-0 flex-1 items-center gap-2 text-left"
            >
              <span className="p-2 rounded-md transition bg-[var(--bg)] group-hover:bg-white">
                <ReactSVG
                  src={opt.icon}
                  beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
                />
              </span>
              <span className="truncate">{opt.label}</span>
            </button>
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onMakeDefault?.(opt);
              }}
              className="shrink-0 rounded-md bg-white px-2 py-1 text-[11px] font-medium text-[#3AB1F6] transition hover:bg-[#EAF7FF]"
            >
              {defaultPromptId === opt.id ? "Default" : "Make default"}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

const SettingsPanel = ({
  dropdownRef,
  isOpen,
  setIsOpen,
  selected,
  setSelected,
  promptOptions,
  onMakeDefault,
  defaultPromptId,
  hastext,
  applyLoading = false,
  onApplySettings,
}) => {
  return (
    <div className="rounded-2xl border border-[#D6ECFB] bg-white p-4">
      <div className="shrink-0 flex items-center gap-3 md:text-[1.75rem] text-xl font-semibold font-inter">
        <span className="bg-gradient-to-b from-[#3AB1F6] to-[#407BFF] text-white p-1.5 rounded-lg">
          <IoMdSettings className="md:size-5 size-4" />
        </span>
        Prompts
      </div>

      <div className="w-full mt-3" ref={dropdownRef}>
        {/* <span className="md:text-xl text-base font-inter font-medium">Prompts</span> */}

        <PromptDropdown
          isMobile={false}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selected={selected}
          promptOptions={promptOptions}
          setSelected={setSelected}
          onMakeDefault={onMakeDefault}
          defaultPromptId={defaultPromptId}
        />

        <PromptDropdown
          isMobile
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selected={selected}
          promptOptions={promptOptions}
          setSelected={setSelected}
          onMakeDefault={onMakeDefault}
          defaultPromptId={defaultPromptId}
        />
      </div>

      {hastext && (
        <button
          onClick={onApplySettings}
          disabled={applyLoading}
          className="w-full mt-4 shrink-0 bg-[#3AB1F6] p-3 rounded-xl text-xl font-inter font-medium text-white"
        >
          {applyLoading ? "Applying..." : "Apply Prompt"}
        </button>
      )}
    </div>
  );
};

export default SettingsPanel;
